export const ENDPOINTS = {
  auth: {
    login: '/users/sign-in',
    me: '/users/me',
    revealCredential: '/users/reveal-credential',
    forgotPassword: '/users/forgot-password',
    resetPassword: '/users/reset-password',
    changePassword: '/users/change-password',
  },
  users: {
    base: '/users',
    me: '/users/me',
    byId: (userId) => `/users/${encodeURIComponent(userId)}`,
    resetPassword: (userId) => `/users/${encodeURIComponent(userId)}/reset-password`,
  },
  batches: {
    base: '/batches',
    byId: (id) => `/batches/${encodeURIComponent(id)}`,
  },
  books: {
    base: '/books',
    byId: (id) => `/books/${encodeURIComponent(id)}`,
  },
  lessons: {
    base: '/lessons',
    byId: (id) => `/lessons/${encodeURIComponent(id)}`,
  },
  elements: {
    base: '/elements',
    byId: (id) => `/elements/${encodeURIComponent(id)}`,
  },
  exercises: {
    base: '/exercises',
    byId: (id) => `/exercises/${encodeURIComponent(id)}`,
    questionMedia: (id) => `/exercises/${encodeURIComponent(id)}/question-media`,
    draft: (id) => `/exercises/${encodeURIComponent(id)}/draft`,
    myDrafts: '/exercises/drafts/mine',
  },
  responses: {
    base: '/responses',
    byId: (id) => `/responses/${encodeURIComponent(id)}`,
  },
  notifications: {
    base: '/notifications',
    byId: (id) => `/notifications/${encodeURIComponent(id)}`,
  },
  analytics: {
    base: '/analytics',
  },
  questionBank: {
    base: '/question-bank',
    byId: (id) => `/question-bank/${encodeURIComponent(id)}`,
  },
  exerciseBank: {
    base: '/exercise-banks',
    byId: (id) => `/exercise-banks/${encodeURIComponent(id)}`,
    fork: (id) => `/exercise-banks/${encodeURIComponent(id)}/fork`,
    importItems: (id) => `/exercise-banks/${encodeURIComponent(id)}/import-items`,
    deploy: (id) => `/exercise-banks/${encodeURIComponent(id)}/deploy`,
    items: (bankId) => `/exercise-banks/${encodeURIComponent(bankId)}/items`,
    itemById: (bankId, itemId) =>
      `/exercise-banks/${encodeURIComponent(bankId)}/items/${encodeURIComponent(itemId)}`,
    reorderItems: (bankId) => `/exercise-banks/${encodeURIComponent(bankId)}/items/reorder`,
  },
  tags: {
    base: '/tags',
    byId: (id) => `/tags/${encodeURIComponent(id)}`,
    renameCategory: '/tags/category/rename',
  },
  progress: {
    base: '/progress',
  },
  batchBooks: {
    base: '/batch-books',
    byId: (id) => `/batch-books/${encodeURIComponent(id)}`,
  },
  bookLessons: {
    base: '/book-lessons',
    byId: (id) => `/book-lessons/${encodeURIComponent(id)}`,
  },
  lessonElements: {
    base: '/lesson-elements',
    byId: (id) => `/lesson-elements/${encodeURIComponent(id)}`,
  },
  lessonExercises: {
    base: '/lesson-exercises',
    byId: (id) => `/lesson-exercises/${encodeURIComponent(id)}`,
  },
  bookCompletions: {
    base: '/book-completions',
    record: '/book-completions/record',
    check: '/book-completions/check',
  },
  auditLogs: {
    base: '/audit-logs',
  },
  uploads: {
    base: '/uploads',
  },
  media: {
    proxy: '/media/proxy',
  },
  zohoRecordings: {
    base: '/zoho-recordings',
    import: '/zoho-recordings/import',
    qualityOptions: '/zoho-recordings/quality-options',
    importJobs: '/zoho-recordings/import-jobs',
    importJob: (jobId) => `/zoho-recordings/import-jobs/${jobId}`,
    cancelImportJob: (jobId) => `/zoho-recordings/import-jobs/${jobId}/cancel`,
    autoImportSettings: '/zoho-recordings/auto-import-settings',
  },
  fees: {
    base: '/fees',
    settings: '/fees/settings',
    my: '/fees/my',
    summary: '/fees/summary',
    export: '/fees/export',
    markPending: '/fees/mark-pending',
    markPaid: '/fees/mark-paid',
    byId: (id) => `/fees/${id}`,
    submit: (id) => `/fees/${id}/submit`,
    reject: (id) => `/fees/${id}/reject`,
  },
  migrate: {
    base: '/migrate',
  },
  me: {
    batchContent: '/me/batch-content',
    bookContent: '/me/book-content',
    studentDashboard: '/me/student-dashboard',
    parentDashboard: '/me/parent-dashboard',
    creatorSummary: '/me/creator-summary',
  },
};
